export default function updateVesselPositionDataToJson(vesselPositionData) {
    return {
        'lat': vesselPositionData.latitude,
        'lon': vesselPositionData.longitude,
        'time': vesselPositionData.date,
    }
}